var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"7","height":"12","viewBox":"0 0 7 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 10.5L2 6L6 1.5","stroke":"#9E785B","stroke-width":"2","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }